<template>
  <div>
    <div
      class="BackgroundVideo"
      :style="modifier"
      ref="container"
      v-window-resize="resize"
    >
      <video
        ref="video"
        :style="videoStyle"
        :muted="muted"
        :autoplay="autoplay"
        :loop="loop"
        :playsinline="playsinline"
        :poster="poster"
        style="object-fit: cover;"
      >
        <!-- <source :src="webmUrl" />
        <source :src="videoUrl" /> -->
        <source :src="videoUrl" />
      </video>
    </div>
    <div
      class="BackgroundVideo-play-container"
      v-if="playable"
      ref="playBtn"
      @click="toggleVideo"
    >
      <div class="BackgroundVideo-play">
        <img :src="iconPlay" />
      </div>
      <span>REPRODUCIR VIDEO</span>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  props: {
    videoUrl: String,
    webmUrl: String,
    poster: String,
    playable: Boolean,
    loop: Boolean,
    playsinline: Boolean,
    fixed: Boolean,
    muted: Boolean,
    autoplay: Boolean,
    width: Number,
    height: Number,
  },
  data: () => ({
    isPlaying: false,
    iconPlay: require("@/assets/img/campaign/0_iconPlay.svg"),
    videoWidth: 0,
    videoHeight: 0,
    videoTop: 0,
    videoLeft: 0,
  
  }),
  mounted() {
    this.resize();
  },
  computed: {
    modifier() {
      const { fixed } = this;
      const position = fixed ? "fixed" : "absolute";
      return `position: ${position}`;
    },
   
    videoStyle: function() {
      return {
        width: `${this.videoWidth}px`,
        height: `${this.videoHeight}px`,
        top: `${this.videoTop}px`,
        left: `${this.videoLeft}px`,
        backgroundImage: `url(${this.$props.poster})`,
      };
    },
  },
  methods: {
    resize: function() {
      const { $refs, $props } = this;
      let elAspect, elWidth, elHeight, elPosTop, elPosLeft;

      let w = $refs.container.clientWidth;
      let h = $refs.container.clientHeight;
      var contAspect = w / h;

      elAspect = $props.width / $props.height;

      if (contAspect > elAspect) {
        elWidth = w;
        elHeight = w / elAspect;
        elPosTop = -(elHeight - h) * 0.5;
        elPosLeft = 0;
      } else {
        elWidth = h * elAspect;
        elHeight = h;
        elPosTop = 0;
        elPosLeft = -(elWidth - w) * 0.5;
      }

      this.videoWidth = elWidth;
      this.videoHeight = elHeight;
      this.videoTop = elPosTop;
      this.videoLeft = elPosLeft;
    },
    onPause() {
      const { $refs } = this;
      gsap.to($refs.playBtn, 0.5, { opacity: 1, ease: "power3.out" });
      this.$emit("pause");
    },
    onPlay() {
      const { $refs } = this;
      gsap.to($refs.playBtn, 0.5, { opacity: 0, ease: "power3.out" });
      this.$emit("play");
    },
    toggleVideo() {
      const { video } = this.$refs;
      const { playable, isPlaying, onPause, onPlay } = this;

      if (!playable) return;

      if (isPlaying) {
        onPause();
        video.pause();
        this.isPlaying = false;
        gsap.set(video, { pointerEvents: "none" });
      } else {
        onPlay();
        video.play();
        this.isPlaying = true;
        gsap.set(video, { pointerEvents: "all" });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './BackgroundVideo.styl';
</style>
